import { GET, POST, createRequest } from "./createRequest";
import { firebaseMessaging } from "./firebaseUtils";
import { it } from "../modules/language/it";

const getMessageString = (intl, text, values = {}) => intl.formatMessage({ id: text, defaultMessage: it[text] }, { ...values });

export { GET, POST, createRequest, getMessageString, firebaseMessaging };
